import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Cliente, TipoCliente, Tarjeta } from 'app/models/data.model';
import { UtilityProvider } from 'app/providers/utility/utility';
import { DataManagement } from 'app/services/dataManagement';
import { Router } from '@angular/router';
import { ClienteForm } from 'app/models/form.model';
import { CryptProvider } from 'app/providers/crypt/crypt';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { RestWS } from 'app/services/restService'


@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class RegisterComponent implements OnInit, OnDestroy {
    registerForm: FormGroup;


    codigoactual: any;
    faceCliente: any;
    haveFace: boolean = false;
    textFace: string = 'FACE LOGIN'
       // CAMARA 

       muestraCamara: boolean = false;
       muestraLogin: boolean = false;
       muestraBuscarCliente: boolean = false;
       contadorCapturas: number = 0;
       
       faces: any;
 
         constraints = {
           video: {
               facingMode: 'user',
               width: { ideal: 300 },
               height: { ideal: 300 }
           },
           videoLogin: {
             facingMode: 'environment',
             width: { ideal: 300 },
             height: { ideal: 300 }
         },
          
         };
 
        
         videoWidth = 0;
         videoHeight = 0;
         stream: any;
       
         elementType = 'url';  
         public imagePath;  
         value : any;  
         @ViewChild('result') resultElement: ElementRef;  
       
         @ViewChild('video') videoElement: ElementRef;
       
         @ViewChild('canvas') canvas: ElementRef;
         @ViewChild('foto') canvasFoto: ElementRef;
   

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private translationLoader: FuseTranslationLoaderService,
        private _formBuilder: FormBuilder,
        private utils: UtilityProvider,
        private cookieService: CookieService,
        private dm: DataManagement,
        private router: Router,
        private crypto: CryptProvider,
        private api: RestWS,
        private renderer: Renderer2,
        private http: RestWS
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(english, spanish);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.registerForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            clave: ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPasswordValidator]],
            razonSocial: ['', Validators.required],
            cif: ['', Validators.required],
            //telefono1: ['', Validators.required],
            telefono1: [''],
            telefono2: [''],
            //nombreComercial: ['', Validators.required],
            nombreComercial: [''],
            // direccionFacturacion: ['', Validators.required],
            direccionFacturacion: [''],
            web: [''],
            codigoPromocional: [''],
            //termsAndConditions: [null, Validators.required],
            contactoNombre: [''],
            //contactoEmail: ['', Validators.email]
            contactoEmail: ['']

            /*numeroTarjeta: [''],
            mesTarjeta: [''],
            anyoTarjeta: [''],
            cvvTarjeta: [''],*/

        });

        // Update the validity of the 'passwordConfirm' field
        // when the 'password' field changes
        this.registerForm.get('clave').valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.registerForm.get('passwordConfirm').updateValueAndValidity();
            });

    }

// CAMARA 

facelogin() {
    this.haveFace = false;
    this.startCamera();
    this.muestraCamara = true;
    this.contadorCapturas = 0;
}

cancelfacelogin() {
    this.stopvideo();
    this.muestraCamara = false;
    this.haveFace = false;
    this.textFace = "FACE LOGIN"
    this.contadorCapturas = 0;
}

stopvideo() {
    this.pauseTimer();
    this.stream.getTracks().forEach(function(track) {
      track.stop();
    });
    this.muestraCamara = false;
}

  dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }

  async capture() {
    this.pauseTimer()
    let canvascara = document.createElement("canvas");
    canvascara.height = 300;
    canvascara.width = 300;
    canvascara.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
    this.value = canvascara.toDataURL("image/png")//.replace("image/png", "image/octet-stream");
    setTimeout( async t => {
            var file = await this.dataURLtoFile(this.value, 'uno.png')
            this.api.isface(file).then( resp => {
                console.log(resp)
                if (resp.isFace) {
                    this.faceCliente = file;
                    this.haveFace = true;
                    this.textFace = ""
                    this.stopvideo()
                } else {
                    this.contadorCapturas ++;
                    if (this.contadorCapturas >= 5) {
                        this.cancelfacelogin()
                    } else {
                        this.startTimer()

                    }
                }
            })
      },500);
  

}

startCamera() {
  
    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { 
        navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
    } else {
        alert('Sorry, camera not available.');
        this.startTimer();
    }
  }
  
  handleError(error) {
  console.log('Error: ', error);
  //this.loading = false;
  }
  
  async attachVideo(stream) {
  
    console.log('atach 1')
    this.stream = stream;
    this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
    await this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
        this.videoHeight = this.videoElement.nativeElement.videoHeight;
        this.videoWidth = this.videoElement.nativeElement.videoWidth;
        this.capture();
    });
  
   
  }
  
  timeLeft: number = 1;
  interval;
  
  startTimer() {
      this.interval = setInterval(() => {
        if(this.timeLeft > 1) {
          this.timeLeft--;
          
        } else {
          this.timeLeft = 1;
          console.log('timer')
          //this.textoFace = 'Capturando Imagen'
          this.capture();
        }
      }, 1000)
    }
  
    pauseTimer() {
      clearInterval(this.interval);
    }
  

//


////////////////



    comprobar_tarjeta() {
        /*
        if (this.comprobar_codigo()) {
            if ( 
                ( this.registerForm.get('mesTarjeta').value !== '')  &&
                ( this.registerForm.get('anyoTarjeta').value !== '')  &&
                ( this.registerForm.get('cvvTarjeta').value !== '') && 
                ( this.validarTarjeta(this.registerForm.get('numeroTarjeta').value ) ) )
            {
                return this.registerForm.invalid
            } else {
                return true;
            }
            
        } else {
            return this.registerForm.invalid;
        }*/
    }

    public comprobar_codigo() {
        let cod: String = this.registerForm.get('codigoPromocional').value;
        this.codigoactual = this.utils.getCodigosPromocionales().filter(codigo => codigo.codigo === cod);
        if (!this.codigoactual[0]) {
            return true
        } else {
            return (this.codigoactual[0].tarjeta)
        }

    }

    async addClient() {
        let formularioCliente: ClienteForm = this.registerForm.getRawValue();
        formularioCliente.tipoCliente = TipoCliente.EMPRESA;
        //console.log(formularioCliente);
        let cliente: Cliente = new Cliente();
        cliente.constructorRegistro(formularioCliente);


        if (cliente.codigoPromocional) {
            let codigoactual = this.utils.getCodigosPromocionales().find(codigo => codigo.codigo === cliente.codigoPromocional);
            if (!codigoactual) {
                this.utils.openDialog(this.utils.WARNING, "El código promocional no existe", false, false);
                return;
            }
        }
        /*this.dm.registrarCliente(cliente).then(res => {
            if (res.status == 'ok') {
                let clienteRegistrado: Cliente = res.message;
                let asunto = "[SmartBiometrik] Confirmación de correo electrónico";
                let mensaje = `<h3>Hola,</h3>
                              <p>Gracias por registrarse en SmartBiometrik</p>
                              <p>Para comenzar a utilizar su cuenta es necesario verificar el correo electrónico. Por favor, haga click en el siguiente enlace:</p>
                              <h3 style="margin-left: 15px"><a href="https://dashboard.smartbiometrik.com/#/pages/auth/mail-confirm/`+ clienteRegistrado.token + `/?email=` + clienteRegistrado.email + `" target="_blank"><strong>Confirmar mi email</strong></a></h3>
                              <br />
                              <p>Si tiene problemas con el enlace, puede copiar y pegar en su navegador la siguiente url:</p>
                              <p>https://dashboard.smartbiometrik.com/#/pages/auth/mail-confirm/`+ clienteRegistrado.token + `/?email=` + clienteRegistrado.email + `</p>
                              <br />
                              <em>Gracias por confiar en SmartBiometrik.</em><br />
                              <em>Un cordial saludo.</em><br />`;
                let mailTo = cliente.email;
                let cc = "";
                let cco = "";
                if (environment.production) {
                    this.cookieService.set('dashSmartBiometrikEmailConfirm', cliente.email, 3, '/', ".smartbiometrik.com", true, "Strict");
                } else {
                    this.cookieService.set('dashSmartBiometrikEmailConfirm', cliente.email, 3, '/', "", false, "Strict");
                }
                this.dm.sendGenericMail(asunto, mensaje, mailTo, cc, cco, true);
                this.createClienteFace(clienteRegistrado);
                this.router.navigateByUrl("pages/auth/mail-confirm");
            } else {
                if (res.message == 'Email exists!!') {
                    this.utils.openDialog(this.utils.WARNING, "El email introducido ya existe.", false, false);

                } else {
                    //console.log("Fallo en el registro de cliente: ", res);
                    this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un fallo en el registro. Inténtelo de nuevo.", false, false);
                }
            }
        }).catch(error => {
            //console.log('Error: ' + error);
            this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un fallo en el registro. Revise su conexión a Internet, gracias.", false, false);
        });*/

        let emailBody = {
            name: formularioCliente.razonSocial,
            email: formularioCliente.email,
            telefono: formularioCliente.telefono1,
            password: formularioCliente.clave,

        }
        let empresa: any = await this.http.createEmpresa(emailBody);
        let emailSended: any = await this.http.sendMail(emailBody);
        if (emailSended.status === 'ok') {
            this.utils.openDialog('Regitro','Se ha recibido su petición de registro. Recibirá un correo de verificación de su cuenta.', false, true);
            this.router.navigateByUrl("pages/auth/login");
        } else {
            this.utils.openDialog('Regitro','Opps, algo fue mal al solicitar el registro.', false, true);
        }


    }

    createClienteFace(cliente) {
       console.log('Crear face: ', cliente)
       if (this.haveFace) {
        this.api.newface(this.faceCliente, cliente._id ).then( resp => {
            console.log('Creada Face: ', resp);
        })
       }
    }

    validarTarjeta(numero_tarjeta) {
        let cadena = numero_tarjeta.toString();
        cadena = cadena.replace(/ /g, "")
        let longitud = cadena.length;
        let cifra = null;
        let cifra_cad = null;
        let suma = 0;
        for (let i = 0; i < longitud; i += 2) {
            cifra = parseInt(cadena.charAt(i)) * 2;
            if (cifra > 9) {
                cifra_cad = cifra.toString();
                cifra = parseInt(cifra_cad.charAt(0)) +
                    parseInt(cifra_cad.charAt(1));
            }
            suma += cifra;
        }
        for (let i = 1; i < longitud; i += 2) {
            suma += parseInt(cadena.charAt(i));
        }

        let numDigitos = longitud == 0 || longitud == 16;

        if (((suma % 10) == 0 && numDigitos)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}

/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const password = control.parent.get('clave');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if (!password || !passwordConfirm) {
        return null;
    }

    if (passwordConfirm.value === '') {
        return null;
    }

    if (password.value === passwordConfirm.value) {
        return null;
    }

    return { passwordsNotMatching: true };
};

/**
 * Confirm card number validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const cardNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if (!control.parent || !control) {
        return null;
    }

    const numero_tarjeta = control.parent.get('numeroTarjeta').value;
    //console.log(numero_tarjeta);
    let cadena = numero_tarjeta.toString();
    cadena = cadena.replace(/ /g, "")
    let longitud = cadena.length;
    let cifra = null;
    let cifra_cad = null;
    let suma = 0;
    for (let i = 0; i < longitud; i += 2) {
        cifra = parseInt(cadena.charAt(i)) * 2;
        if (cifra > 9) {
            cifra_cad = cifra.toString();
            cifra = parseInt(cifra_cad.charAt(0)) +
                parseInt(cifra_cad.charAt(1));
        }
        //console.log(cifra);
        suma += cifra;
    }
    for (let i = 1; i < longitud; i += 2) {
        suma += parseInt(cadena.charAt(i));
    }

    //let numDigitos = longitud == 0 || longitud == 16;
    let numDigitos = longitud === 16;
    //console.log("suma", suma);
    //console.log("numDigitos", numDigitos);
    //console.log("longitud", longitud);
    if (((suma % 10) == 0 && numDigitos)) {
        return null;
    } else {
        return { cardNumberNotMatching: true };
    }
};



